



















import IconClose from "@/components/icons/IconClose.vue";

export default {
  name: "CartTable",
  components: { IconClose },
  props: {
    action: { type: Function, default: () => null },
    type: { type: String, default: "table" },
    title: { type: String, default: "" },
  },
};
